// extracted by mini-css-extract-plugin
module.exports = {"form":"medicalGuide_form__1H8Ig","tip":"medicalGuide_tip__18sZd","buttonMain":"medicalGuide_buttonMain__xJMW1"};